import { createContext, useContext, useState, useCallback } from 'react'

const LoadingContext = createContext(null)

export const useLoading = () => {
  const context = useContext(LoadingContext)
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider')
  }
  return context
}

export const LoadingProvider = ({ children }) => {
  const [pendingRequests, setPendingRequests] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  const startLoading = useCallback(() => {
    setPendingRequests((prev) => {
      const newCount = prev + 1
      setIsLoading(newCount > 0)
      return newCount
    })
  }, [])

  const stopLoading = useCallback(() => {
    setPendingRequests((prev) => {
      const newCount = Math.max(0, prev - 1)
      setIsLoading(newCount > 0)
      return newCount
    })
  }, [])

  const resetLoading = useCallback(() => {
    setPendingRequests(0)
    setIsLoading(false)
  }, [])

  return (
    <LoadingContext.Provider
      value={{
        isLoading,
        pendingRequests,
        startLoading,
        stopLoading,
        resetLoading
      }}
    >
      {children}
    </LoadingContext.Provider>
  )
}
